import React from 'react';

interface EstadoErroProps {
  titulo?: string;
  descricao?: string;
  onTentarNovamente?: () => void;
}

const EstadoErro: React.FC<EstadoErroProps> = ({
  titulo = 'Não foi possível carregar esta informação',
  descricao = 'Tente novamente em instantes.',
  onTentarNovamente,
}) => (
  <div className='mc-estado mc-estado--erro'>
    <i className='bi bi-exclamation-triangle' />
    <strong>{titulo}</strong>
    <p>{descricao}</p>
    {onTentarNovamente && (
      <button type='button' className='mc-btn mc-btn--secondary mc-btn--sm' onClick={onTentarNovamente}>Tentar novamente</button>
    )}
  </div>
);

export const EstadoSemPermissao: React.FC<{ recurso: string }> = ({ recurso }) => (
  <div className='mc-estado mc-estado--sem-permissao'>
    <i className='bi bi-lock' />
    <strong>Sem permissão</strong>
    <p>Seu perfil não tem acesso a "{recurso}". Fale com o administrador do Maestro para solicitar liberação.</p>
  </div>
);

export default EstadoErro;
